module.exports = __webpack_public_path__ + "static/media/cvd.3f7bc93e.png";